import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import styles from '../../EventLiabilityStyles.module.scss'
import presentationMetadata from './PropertyCoveragesPage.metadata.json5';
import messages from './PropertyCoveragesPage.messages';
import CoveragesPageComponent from "../Coverages/CoveragesPage";
import AddlInterestTextBoxComponent from "../../components/AddlInterestTextBoxComponent/AddlInterestTextBoxComponent";

function PropertyCoveragesPage(props) {
    const {
        wizardData: submissionVM, updateWizardData, currentStep, callbackMap
    } = props;
    const { pageKey } = currentStep;
    // eslint-disable-next-line security/detect-object-injection
    const metadata = presentationMetadata[pageKey];
    const { initialValidation, onValidate } = useValidation('PropertyPage');
    const { lineName } = PremierConstants;
    const { updateSubmission } = useUpdateSubmissionServices();

    const onNext = useCallback(
        async () => {

            const { productCode } = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);

            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const getAccordianTitle = useCallback((index) => (
        <div className={styles.accordianTitle}>
            <p>
            {_.get(
                submissionVM.value,
                `lobData.eveLiaLine.coverables.locRisks[${index}].accountLocFie.displayName`
            )}
            </p>
        </div>
    ),[submissionVM]);

    const propertyCoveragesOverrides = useMemo(() => {
        const informationList = _.get(submissionVM, 'lobData.eveLiaLine.coverables.locRisks', []);
        let overrides = [];

        if (!_.isEmpty(informationList)) {
            overrides = informationList?.children.map((information, index) => ({
                [`locRiskCoverageComponent${index}`]: {
                    wizardData: submissionVM,
                    updateWizardData,
                    clausesBasePath: `lobData.eveLiaLine.lineCoverages.locRiskCoverages.plecoverages.children[${index}].coverages`,
                    title: messages.cov,
                    clasueType: 'coverages',
                    pathToGet: `eveLiaLine.locRiskCoverages.plecoverages[${index}].coverages`
                },
                [`propertyCoveragesAccordionDetails${index}`]: {                     
                    title: getAccordianTitle(index),
                    className: styles.gwOuterLocationAccordion
                },
                [`propertyCoveragesAccordion${index}`]: {
                    className: styles.gwAccordionSet
                },
                [`additionalInterest${index}`]:{
                    wizardData: submissionVM,
                    updateWizardData,
                    addlIntPath: `lobData.eveLiaLine.coverables.locRisks.children[${index}].additionalInterests`,
                    isLineLevel: false
                },
            }));
        }

        return Object.assign({}, ...overrides);
    }, [getAccordianTitle, updateWizardData, submissionVM]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        ...propertyCoveragesOverrides
    };

    const resolveCallbackMap = {
        ...callbackMap
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, submissionVM, id, path, overrideProps),
        [metadata.content, submissionVM, overrideProps]
    );

    const resolveComponentMap = {
        coveragespagecomponent: CoveragesPageComponent,
        AddlInterestTextBoxComponent
    };

    const isDisableNext = () => {
        let result = false
        
        _.each(submissionVM.value.lobData.eveLiaLine.coverables.locRisks, (locRisk) => {
            if (!result && !_.isUndefined(_.find(locRisk.coverages.coverages, { isValid: false }))) {
                result = true
            }
        });

        return result
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={() => initialValidation}
            disableNext={isDisableNext()}
            disableSave={isDisableNext()}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={submissionVM}
                onModelChange={updateWizardData}
                callbackMap={resolveCallbackMap}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                componentMap={resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

PropertyCoveragesPage.propTypes = wizardProps;
export default withViewModelService(PropertyCoveragesPage);
